import React from "react";

const Error=()=>{
    return(
        <>
            <h1>Oops page Not Found !!</h1>
        </>
    )
}
export default Error;